// extracted by mini-css-extract-plugin
module.exports = {"power-backup-A":"A_power-backup-A__gp1N0"};